'use strict';

const TokenParser = require('../../models/token-parser');
module.exports = function authenticationAWSModels(lib, config, goldApi, navigatorShim, windowObj, ajaxPromise, optional) {
	if (!lib || !config || !config.googleOauthClientId || !goldApi || !navigatorShim || !windowObj || !ajaxPromise) {
		throw new Error('invalid-args');
	}
	const authenticationModel = new lib.AuthenticationModel({storage: navigatorShim.getJsonStorage()}),
		allowUnlicensed = !!(optional && optional.allowUnlicensed),
		noCognito = !(config && config.cognito),
		taskRetrier = new lib.TaskRetrier(navigatorShim),
		subscriptionModel = new lib.SubscriptionModel(authenticationModel, goldApi, navigatorShim.getHostName(), taskRetrier, {getGoldAccountDetailsOnRegistration: noCognito}),
		googleShim = new lib.GoogleShim({
			client_id: config.googleOauthClientId,
			scope: 'email profile'
		}, navigatorShim, ajaxPromise),
		microsoftAuthShim = new lib.MicrosoftAuthShim({
			client_id: config.microsoftAppId,
			scope: (optional && optional.microsoftAuthScopes) || 'User.Read openid profile'
		}, navigatorShim, ajaxPromise),
		storageName = (optional && optional.storageName) || 'gold',
		microsoftOAuthApi = new lib.OAuthApi(microsoftAuthShim), //TODO-> rename to OauthAuthApi
		tokenParser = new TokenParser(),
		microsoftAuthenticator = new lib.MicrosoftAuthenticator({microsoftOAuthApi, authenticationModel, goldApi, tokenParser}),

		googleAuthApi = new lib.OAuthApi(googleShim),
		googleAuthenticator = new lib.GoogleAuthenticator(googleAuthApi, goldApi, storageName, {}, {authenticationModel: authenticationModel, requireConfirmation: true, allowUnlicensed: allowUnlicensed}),
		googleReauthenticator = new lib.GoogleAuthenticator(googleAuthApi, goldApi, storageName, {}, {authenticationModel: authenticationModel, requireConfirmation: false, allowUnlicensed: allowUnlicensed}),
		reauthenticatorStorage = (optional && optional.reauthenticatorStorage) || navigatorShim.getJsonStorage(),
		reauthenticator = new lib.Reauthenticator(authenticationModel, [googleReauthenticator, microsoftAuthenticator], reauthenticatorStorage),
		oneTimePasswordAuthenticator = new lib.OneTimePasswordAuthenticator(goldApi, authenticationModel),
		microsoftTeamsIdentityProvider = new lib.MicrosoftTeamsIdentityProvider({microsoftOAuthApi}),
		affiliateProviders = [microsoftTeamsIdentityProvider],
		affiliateTeamIdentityProvider = new lib.AffiliateTeamIdentityProvider({affiliateProviders, subscriptionModel});

	return {authenticationModel, reauthenticator, oneTimePasswordAuthenticator, googleAuthenticator, googleShim, microsoftOAuthApi, microsoftAuthenticator, subscriptionModel, microsoftTeamsIdentityProvider, affiliateTeamIdentityProvider};
};
